import { MouseEventHandler } from 'react';
import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  children: JSX.Element;
  count: number;
  onConfirm: MouseEventHandler<HTMLButtonElement>;
  onReset: MouseEventHandler<HTMLButtonElement>;
  onClose: MouseEventHandler<HTMLButtonElement>;
}

export default function Container({
  children,
  count,
  onConfirm,
  onReset,
  onClose,
}: IProps) {
  return (
    <div className={cx('Container')} role="dialog">
      <div className={cx('content')}>
        <div className={cx('heading')}>
          <b className={cx('title')}>상세조건</b>
          <button
            className={cx('reset')}
            type="button"
            aria-label="초기화"
            onClick={onReset}
            data-event-nlog="click"
            data-event-area-code="rtf.filterrefresh"
          />
          <button
            className={cx('close')}
            type="button"
            aria-label="닫기"
            onClick={onClose}
            data-event-nlog="click"
            data-event-area-code="rtf.filterclose"
          />
        </div>
        {children}
        <div className={cx('footer')}>
          <span className={cx('current')}>
            <span className={cx('name')}>상품</span>{' '}
            <b className={cx('count')}>{count}</b>
          </span>
          <div className={cx('btns')}>
            <button
              className={cx('submit')}
              type="submit"
              onClick={onConfirm}
              data-event-nlog="click"
              data-event-area-code="rtf.filterapply"
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
